import React from 'react'
import { FaUsers } from "react-icons/fa6";
import { TfiLayoutListThumbAlt } from "react-icons/tfi";
import FormatMomentDate from 'Utils/FormatMomentDate';
import { genderIdentifier } from 'Utils/genderIdentifier';
import { IoIosWallet } from "react-icons/io";
import ClaimIcon from 'SVGS/ClaimIcon';
import PatientIcon from 'SVGS/PatientIcon';
import PaymentIcon from 'SVGS/PaymentIcon';
const GlobalSearchItem = ({ list, index, gotoSearchModule, selected }) => {

    return (
        <button onClick={() => gotoSearchModule(list)} id={`globalSearchInput_${index}`} key={index} className={`flex items-center w-full gap-5 px-4 py-1 transition-all  rounded text-secondaryLight cursor-pointer  hover:bg-gray-100 ${selected ? "bg-gray-100" : ''} `}>
            {list.source === "Patient" ? <PatientIcon /> :
                list.source === "Claim" ? <ClaimIcon /> : <PaymentIcon />

            }

            <div className='flex flex-col items-start w-full gap-2'>
                <div>
                    <span className='text-sm font-semibold text-black'>{list.label}</span>
                    <span className='bg-[#F8F8FA] text px-2 text-xs py-1 text-[#696774] ml-4 rounded font-semibold'>{list.source}</span>
                    {list.sourceType && <span className='bg-[#F8F8FA] text px-2 text-xs py-1 text-[#696774] ml-4 rounded font-semibold'>{list.sourceType}</span>}

                </div>
                <div className='text-sm '>{list.accountNumber} | {list.source === "Claim" || list.source === "Payment" ? list.gender : genderIdentifier(list.gender)} | {FormatMomentDate(list.dateValue)} | Payer : <span className='font-semibold'>{list.payerName}</span></div>
            </div>
        </button>
    )
}

export default GlobalSearchItem